// Merkan · Englisches Wörterbuch für die Stammdaten (Kunden, Lieferanten, Schiffe, Artikel)
export default {
  "Stammdaten": "Master Data",
  "Artikel": "Items",
  "Ersatzteile und Dienstleistungen mit Teilenummer, Lieferanten und Preisen": "Spare parts and services with part number, suppliers and prices",
  "Neuer Artikel": "New item",
  "Alle Artikel zeigen": "Show all items",
  "Nur diese Artikel zeigen": "Show these items only",
  "Teilenummer, Bezeichnung, Lieferantennummer": "Part number, description, supplier number",
  "Alle": "All",
  "Ware": "Goods",
  "Dienstleistung": "Service",
  "Nach Hersteller filtern": "Filter by manufacturer",
  "Alle Hersteller": "All manufacturers",
  "Nach Kategorie filtern": "Filter by category",
  "Alle Kategorien": "All categories",
  "Nach Aggregat filtern": "Filter by unit",
  "Alle Aggregate": "All units",
  "Nach Lieferant filtern": "Filter by supplier",
  "Alle Lieferanten": "All suppliers",
  "Nach Tag filtern": "Filter by tag",
  "Weiterer Tag": "Add tag",
  "Tags": "Tags",
  "Filter {tag} entfernen": "Remove filter {tag}",
  "Filter zurücksetzen": "Reset filters",
  "{n} von {gesamt}": "{n} of {gesamt}",
  "Keine Treffer": "No matches",
  "Noch keine Artikel": "No items yet",
  "Suche oder Filter anpassen.": "Adjust the search or filters.",
  "Artikelnummer": "Item number",
  "Teilenummer": "Part number",
  "Bezeichnung": "Description",
  "Hersteller": "Manufacturer",
  "Kategorie": "Category",
  "EK": "Purchase price",
  "VK": "Sales price",
  "Marge": "Margin",
  "Einheit": "UoM",
  "Offener Preisvorschlag": "Open price proposal",
  "Gebraucht": "Used",
  "Inaktiv": "Inactive",
  "{n} offener Preisvorschlag aus Lieferantenangeboten.": "{n} open price proposal from supplier quotations.",
  "{n} offene Preisvorschläge aus Lieferantenangeboten.": "{n} open price proposals from supplier quotations.",
  "Preisverlauf {verlauf}": "Price history {verlauf}",
  "Artikel nicht gefunden": "Item not found",
  "Dieser Artikel existiert nicht oder ist für dich nicht sichtbar.": "This item does not exist or is not visible to you.",
  "Zur Artikelliste": "Back to item list",
  "Lieferant": "Supplier",
  "Bitte einen Lieferanten wählen.": "Please select a supplier.",
  "Bitte einen Preis größer null eintragen.": "Please enter a price greater than zero.",
  "Preis erfasst.": "Price recorded.",
  "Preisvorschlag verworfen.": "Price proposal discarded.",
  "Einkaufspreis übernommen, VK angepasst.": "Purchase price applied, sales price adjusted.",
  "Einkaufspreis übernommen.": "Purchase price applied.",
  "Einkaufspreis übernehmen?": "Apply purchase price?",
  "Der Einkaufspreis bei {firma} beträgt": "The purchase price from {firma} is",
  "am Artikel stehen": "the item currently shows",
  "Soll der Artikel diesen EK übernehmen?": "Should the item take over this purchase price?",
  "EK übernehmen": "Apply purchase price",
  "Standardlieferant entfernt.": "Default supplier removed.",
  "{firma} ist jetzt Standardlieferant.": "{firma} is now the default supplier.",
  "Lieferant entfernen?": "Remove supplier?",
  "Die Zuordnung zu {firma} mit Nummer und Preisen wird gelöscht. Der Preisverlauf bleibt erhalten.": "The link to {firma}, including number and prices, will be deleted. The price history is kept.",
  "Entfernen": "Remove",
  "Lieferant entfernt.": "Supplier removed.",
  "Übersicht": "Overview",
  "Lieferanten": "Suppliers",
  "Preisverlauf": "Price history",
  "Vorgänge": "Cases",
  "Bearbeiten": "Edit",
  "Offene Preisvorschläge": "Open price proposals",
  "Neuer Einkaufspreis von": "New purchase price from",
  "statt": "instead of",
  "(bisher kein Preis hinterlegt)": "(no price on file so far)",
  "aus Vorgang": "from case",
  "öffnen": "open",
  "Übernehmen": "Apply",
  "Übernehmen und VK mit gleicher Marge anpassen": "Apply and adjust sales price at same margin",
  "Verwerfen": "Discard",
  "EK netto": "Purchase price net",
  "offen": "open",
  "VK netto": "Sales price net",
  "je {einheit} · USt {satz} %": "per {einheit} · VAT {satz}%",
  "Aufschlag {prozent}": "Mark-up {prozent}",
  "Standardlieferant": "Default supplier",
  "keiner": "none",
  "Art": "Type",
  "nicht angegeben": "not specified",
  "Aggregat": "Unit",
  "Zustand": "Condition",
  "Neu": "New",
  "Beschreibung": "Description",
  "Zoll und Versand": "Customs and shipping",
  "Zolltarifnummer": "HS code",
  "fehlt": "missing",
  "Ursprung": "Origin",
  "Gewicht": "Weight",
  "Lieferanten und Lieferanten-Artikelnummern": "Suppliers and supplier item numbers",
  "Lieferant zuordnen": "Assign supplier",
  "Noch kein Lieferant zugeordnet": "No supplier assigned yet",
  "Je Lieferant lassen sich eigene Artikelnummer, Bezeichnung und Preise hinterlegen.": "Each supplier can have its own item number, description and prices.",
  "Standard": "Default",
  "Bezeichnung beim Lieferanten": "Supplier description",
  "Lieferzeit": "Lead time",
  "Preisstand": "Price as of",
  "Aktionen": "Actions",
  "Standardlieferant, klicken zum Entfernen": "Default supplier, click to remove",
  "Als Standardlieferant festlegen": "Set as default supplier",
  "inaktiv": "inactive",
  "{n} Tage": "{n} days",
  "Preisverlauf je Lieferant": "Price history by supplier",
  "Preis erfassen": "Record price",
  "Noch keine Preise erfasst": "No prices recorded yet",
  "Preise aus Kalkulationen und Lieferantenangeboten erscheinen hier automatisch.": "Prices from costings and supplier quotations appear here automatically.",
  "Letzter Preis": "Last price",
  "Stand": "As of",
  "Verlauf": "History",
  "Vorgänge mit diesem Artikel": "Cases with this item",
  "Der Artikel kommt in keinem Vorgang vor": "This item does not appear in any case",
  "Nummer": "Number",
  "Betreff": "Subject",
  "Menge": "Qty",
  "VK je Einheit": "Sales price per unit",
  "Schritt": "Step",
  "Angelegt": "Created",
  "Abbrechen": "Cancel",
  "Speichern": "Save",
  "Lieferant *": "Supplier *",
  "Bitte wählen": "Please select",
  "Einkaufspreis netto (Euro) *": "Purchase price net (EUR) *",
  "Lieferzeit in Tagen": "Lead time in days",
  "Quelle": "Source",
  "z. B. Lieferantenangebot vom 12.10.": "e.g. supplier quotation of 12 Oct",
  "{n} Lieferant": "{n} supplier",
  "{n} Lieferanten": "{n} suppliers",
  "{n} Preis": "{n} price",
  "{n} Preise": "{n} prices",
  "Rechnung": "Invoice",
  "Vorkasse": "Payment in advance",
  "50 % bei Auftragsbestätigung, 50 % bei Versandbereitschaft": "50% on order confirmation, 50% when ready for shipment",
  "Interessent zu Kunde umwandeln?": "Convert prospect to customer?",
  "{firma} wird als Kunde geführt. Die Änderung erscheint im Änderungsprotokoll.": "{firma} will be managed as a customer. The change is recorded in the change log.",
  "Umwandeln": "Convert",
  "{firma} ist jetzt Kunde.": "{firma} is now a customer.",
  "Kunden": "Customers",
  "Kunde": "Customer",
  "Kunde nicht gefunden": "Customer not found",
  "Dieser Kunde existiert nicht oder ist für dich nicht sichtbar.": "This customer does not exist or is not visible to you.",
  "Zur Kundenliste": "Back to customer list",
  "Kontakte": "Contacts",
  "Schiffe": "Vessels",
  "Belege": "Documents",
  "Nachrichten": "Messages",
  "Interessent": "Prospect",
  "Zu Kunde umwandeln": "Convert to customer",
  "Adresse und Kontakt": "Address and contact",
  "Firma": "Company",
  "Kurzname": "Short name",
  "Anschrift": "Address",
  "E-Mail": "Email",
  "keine": "none",
  "Rechnungen an": "Invoices to",
  "Telefon": "Phone",
  "Domain": "Domain",
  "Steuer und Zahlung": "Tax and payment",
  "Steuerart": "Tax category",
  "USt-IdNr.": "VAT ID",
  "Leitweg-ID": "Leitweg ID (German e-invoicing)",
  "Sprache": "Language",
  "Zahlungsart": "Payment method",
  "Zahlungsziel": "Payment terms",
  "Eingangsbestätigung": "Acknowledgement of receipt",
  "automatisch": "automatic",
  "aus": "off",
  "Kreditlimit": "Credit limit",
  "Änderung nur mit Recht Kreditlimit ändern": "Changes require the permission to change credit limits",
  "Offene Posten": "Open Items",
  "minus": "less",
  "Offene Vorgänge ({n})": "Open cases ({n})",
  "Freies Limit": "Available limit",
  "Das Limit ist überschritten. Neue Aufträge nur mit Freigabe oder gegen Vorkasse.": "The limit has been exceeded. New orders only with approval or payment in advance.",
  "Kein Kreditlimit hinterlegt.": "No credit limit on file.",
  "Notiz": "Note",
  "Keine Schiffe zugeordnet": "No vessels linked",
  "Schiffe werden in der Schiffsakte als Eigner, Manager oder Charterer verknüpft.": "Vessels are linked in the vessel record as owner, manager or charterer.",
  "Schiff": "Vessel",
  "Typ": "Type",
  "Flagge": "Flag",
  "Rolle": "Role",
  "Eigner": "Owner",
  "Manager": "Manager",
  "Charterer": "Charterer",
  "Noch keine Vorgänge": "No cases yet",
  "Erwarteter Wert": "Expected value",
  "Noch keine Belege": "No documents yet",
  "Beleg": "Document",
  "Datum": "Date",
  "Fällig": "Due",
  "Status": "Status",
  "Brutto": "Gross",
  "Entwurf": "Draft",
  "Keine Nachrichten zugeordnet": "No messages linked",
  "Von": "From",
  "Empfangen": "Received",
  "(ohne Betreff)": "(no subject)",
  "gesendet": "sent",
  "Reedereien, Shipmanagement und Interessenten": "Shipowners, ship managers and prospects",
  "Neuer Kunde": "New customer",
  "Firma, Nummer, Ort, USt-IdNr.": "Company, number, city, VAT ID",
  "Interessenten": "Prospects",
  "Nur aktive": "Active only",
  "Noch keine Kunden": "No customers yet",
  "Suchbegriff oder Filter anpassen.": "Adjust the search term or filters.",
  "Ort / Land": "City / Country",
  "Ansprechpartner": "Contact person",
  "Lieferant nicht gefunden": "Supplier not found",
  "Dieser Lieferant existiert nicht oder ist für dich nicht sichtbar.": "This supplier does not exist or is not visible to you.",
  "Zur Lieferantenliste": "Back to supplier list",
  "Bezugsquellen": "Sources",
  "Sortiment und Konditionen": "Range and terms",
  "Marken": "Brands",
  "Preise aus Lieferantenangeboten erscheinen hier je Artikel.": "Prices from supplier quotations appear here by item.",
  "Preise": "Prices",
  "Bezugsquellen für Original- und gleichwertige Ersatzteile": "Sources for genuine and equivalent spare parts",
  "Neuer Lieferant": "New supplier",
  "Firma, Nummer, Marke, Ort": "Company, number, brand, city",
  "Nach Marke filtern": "Filter by brand",
  "Alle Marken": "All brands",
  "Noch keine Lieferanten": "No suppliers yet",
  "Schiff nicht gefunden": "Vessel not found",
  "Dieses Schiff existiert nicht oder ist für dich nicht sichtbar.": "This vessel does not exist or is not visible to you.",
  "Zur Schiffsliste": "Back to vessel list",
  "seit {monat} {name}, vorher {alt}": "since {monat} {name}, formerly {alt}",
  "unbekannt": "unknown",
  "({von} bis {bis})": "({von} to {bis})",
  "insgesamt {n} Namen": "{n} names in total",
  "Anlieferhinweise gespeichert.": "Delivery instructions saved.",
  "Bitte die Art des Aggregats eintragen, z. B. Hauptmotor.": "Please enter the type of unit, e.g. main engine.",
  "Aggregat angelegt.": "Unit created.",
  "Aggregat gespeichert.": "Unit saved.",
  "Aggregat löschen?": "Delete unit?",
  "{aggregat} wird aus der Schiffsakte entfernt.": "{aggregat} will be removed from the vessel record.",
  "Löschen": "Delete",
  "Aggregat gelöscht.": "Unit deleted.",
  "nicht zugeordnet": "not assigned",
  "IMO fehlt": "IMO missing",
  "Öffnet Equasis, die IMO wird in die Zwischenablage kopiert": "Opens Equasis; the IMO number is copied to the clipboard",
  "IMO {imo} kopiert, in Equasis einfügen.": "IMO {imo} copied, paste it into Equasis.",
  "Schiffsdaten": "Vessel particulars",
  "Rufzeichen": "Call sign",
  "keines": "none",
  "Heimathafen": "Port of registry",
  "Baujahr": "Year built",
  "BRZ / tdw": "GT / DWT",
  "k. A.": "n/a",
  "Klassifikation": "Classification society",
  "Beziehungen": "Relationships",
  "Anlieferhinweise": "Delivery instructions",
  "Üblicher Agent, Häfen, Liegeplätze, Besonderheiten": "Usual agent, ports, berths, special requirements",
  "Keine Hinweise. Agent, Häfen und Besonderheiten werden beim Versand vorgeschlagen.": "No instructions. Agent, ports and special requirements are suggested at shipping.",
  "Historie": "History",
  "Wird bei Änderungen automatisch geschrieben": "Recorded automatically on changes",
  "seit {monat} {wert}": "since {monat} {wert}",
  "entfernt": "removed",
  "{art}, vorher {alt}": "{art}, formerly {alt}",
  "Quelle: {quelle}": "Source: {quelle}",
  "Erster bekannter Name {name}": "First known name {name}",
  "Baujahr {jahr}": "Built {jahr}",
  "vor der ersten erfassten Änderung": "before the first recorded change",
  "In Merkan angelegt als {name}": "Created in Merkan as {name}",
  "{datum}, seitdem keine Änderung von Name, Flagge, Eigner oder Manager": "{datum}, no change of name, flag, owner or manager since",
  "Aggregate an Bord": "Units on board",
  "Keine Aggregate erfasst": "No units recorded",
  "Hauptmotor, Hilfsdiesel, Separatoren und Pumpen mit Hersteller und Typ.": "Main engine, auxiliary engines, separators and pumps with manufacturer and type.",
  "Hersteller / Typ": "Manufacturer / Type",
  "Seriennummer": "Serial number",
  "Vorgänge zum Schiff": "Cases for this vessel",
  "auch unter früheren Namen": "including former names",
  "Noch keine Vorgänge zu diesem Schiff": "No cases for this vessel yet",
  "damals {name}": "then {name}",
  "Neues Aggregat": "New unit",
  "{name} bearbeiten": "Edit {name}",
  "Art *": "Type *",
  "z. B. MAN, Wärtsilä": "e.g. MAN, Wärtsilä",
  "z. B. 7L58/64": "e.g. 7L58/64",
  "Schiffsstamm mit IMO-Nummer, Beziehungen und Historie": "Vessel register with IMO number, relationships and history",
  "Neues Schiff": "New vessel",
  "Name, frühere Namen, IMO, MMSI": "Name, former names, IMO, MMSI",
  "Nach Schiffstyp filtern": "Filter by vessel type",
  "Alle Schiffstypen": "All vessel types",
  "Noch keine Schiffe": "No vessels yet",
  "Präfix": "Prefix",
  "Name": "Name",
  "früher {name}": "formerly {name}",
  "Bitte eine Artikelnummer eintragen.": "Please enter an item number.",
  "Bitte die Bezeichnung eintragen.": "Please enter the description.",
  "Die Zolltarifnummer hat 8 Ziffern (Warennummer) oder 11 Ziffern.": "The HS code has 8 digits (commodity code) or 11 digits.",
  "Das Ursprungsland bitte als zweistelligen Code eintragen, z. B. DE.": "Please enter the country of origin as a two-letter code, e.g. DE.",
  "Preise dürfen nicht negativ sein.": "Prices must not be negative.",
  "Der Verkaufspreis ist keine gültige Zahl.": "The sales price is not a valid number.",
  "Der Einkaufspreis ist keine gültige Zahl.": "The purchase price is not a valid number.",
  "Die Teilenummer {nummer} von {hersteller} ist bereits als {artikel} angelegt.": "Part number {nummer} from {hersteller} already exists as {artikel}.",
  "Artikel {nummer} angelegt.": "Item {nummer} created.",
  "Artikel gespeichert.": "Item saved.",
  "Nur die Bezeichnung ist Pflicht": "Only the description is mandatory",
  "Speichert": "Saving",
  "Anlegen": "Create",
  "Vorhandenen Artikel öffnen": "Open existing item",
  "Ohne Lager, Gewicht und Zolldaten": "No stock, weight or customs data",
  "Ersatzteil oder Material": "Spare part or material",
  "Bezeichnung *": "Description *",
  "z. B. Servicetechniker an Bord": "e.g. service engineer on board",
  "z. B. Kolbenring, Kompressionsring": "e.g. piston ring, compression ring",
  "Identifikation": "Identification",
  "Automatisch vergeben": "Assigned automatically",
  "z. B. MAN": "e.g. MAN",
  "Teilenummer des Herstellers": "Manufacturer part no.",
  "Empfohlen: Hersteller oder Teilenummer, damit Anfragen den Artikel später zuverlässig finden.": "Recommended: manufacturer or part number, so that enquiries reliably find the item later.",
  "Diese Teilenummer ist bei diesem Hersteller bereits angelegt": "This part number already exists for this manufacturer",
  "Diese Teilenummer gibt es bereits": "This part number already exists",
  "Als Lieferanten-Artikelnummer bekannt": "Known as a supplier item number",
  "Ähnliche Teilenummern": "Similar part numbers",
  "EK netto (Euro)": "Purchase price net (EUR)",
  "0,00": "0.00",
  "VK netto (Euro)": "Sales price net (EUR)",
  "Marge in %": "Margin in %",
  "Eingabe berechnet den VK": "Entry calculates the sales price",
  "Erst EK eintragen": "Enter purchase price first",
  "Aufschlag in %": "Mark-up in %",
  "Der VK liegt unter dem EK ({prozent} Marge).": "The sales price is below the purchase price ({prozent} margin).",
  "Einordnung": "Classification",
  "Aus vorhandenen Artikeln mit gleichem Hersteller oder Aggregat": "From existing items with the same manufacturer or unit",
  "Vorschlag: {kategorie}": "Suggestion: {kategorie}",
  "z. B. Hauptmotor": "e.g. main engine",
  "Zusatzangaben": "Additional details",
  "Einheit, USt, Beschreibung": "UoM, VAT, description",
  "Einheit, USt, Zoll, Ursprung, Gewicht, Zustand": "UoM, VAT, customs, origin, weight, condition",
  "USt-Satz in %": "VAT rate in %",
  "8 Ziffern": "8 digits",
  "Ursprungsland": "Country of origin",
  "z. B. DE": "e.g. DE",
  "Gewicht in kg": "Weight in kg",
  "Aktiv": "Active",
  "Bitte gültige Preise eintragen, z. B. 118,00.": "Please enter valid prices, e.g. 118.00.",
  "Lieferant gespeichert.": "Supplier saved.",
  "Lieferant zugeordnet.": "Supplier assigned.",
  "Lieferant bearbeiten": "Edit supplier",
  "Artikelnummer beim Lieferanten": "Supplier item number",
  "Oft abgekürzt, hilft beim Erkennen von Angeboten": "Often abbreviated, helps recognise quotations",
  "nicht berechenbar": "not calculable",
  "Aufschlag": "Mark-up",
  "Leer lassen: heute bei Preisänderung": "Leave empty: today when the price changes",
  "Aktiv als Bezugsquelle": "Active as source",
  "Stk": "pcs",
  "Satz": "set",
  "Stunde": "hour",
  "Pauschale": "lump sum",
  "Tag": "day",
  "Deutsch": "German",
  "Englisch": "English",
  "Original": "Original",
  "gleichwertig": "equivalent",
  "gebraucht": "used",
  "Schiffstyp": "Vessel type",
  "Die IMO-Nummer hat genau sieben Ziffern.": "The IMO number has exactly seven digits.",
  "Prüfziffer stimmt nicht: Die Summe {summe} ergibt Prüfziffer {pruef}, eingegeben ist {ziffer}. Bitte die Nummer prüfen.": "Check digit does not match: the sum {summe} gives check digit {pruef}, but {ziffer} was entered. Please check the number.",
  "DE + 9 Ziffern": "DE + 9 digits",
  "ATU + 8 Ziffern": "ATU + 8 digits",
  "NL + 9 Ziffern + B + 2 Ziffern": "NL + 9 digits + B + 2 digits",
  "DK + 8 Ziffern": "DK + 8 digits",
  "FR + 2 Zeichen + 9 Ziffern": "FR + 2 characters + 9 digits",
  "EL + 9 Ziffern": "EL + 9 digits",
  "GB + 9 oder 12 Ziffern": "GB + 9 or 12 digits",
  "Die USt-IdNr. beginnt mit dem Länderpräfix, z. B. DE123456789.": "The VAT ID starts with the country prefix, e.g. DE123456789.",
  "Länderpräfix {land} ist unbekannt.": "Country prefix {land} is unknown.",
  "Griechenland verwendet das Präfix EL.": "Greece uses the prefix EL.",
  "Format passt nicht zu {land} ({beispiel}).": "Format does not match {land} ({beispiel}).",
  "Format passt nicht zu {land}.": "Format does not match {land}.",
  "Bitte den Nachnamen eintragen.": "Please enter the surname.",
  "Die E-Mail-Adresse ist ungültig.": "The email address is invalid.",
  "Kontakt angelegt.": "Contact created.",
  "Kontakt gespeichert.": "Contact saved.",
  "{name} ist jetzt Hauptkontakt.": "{name} is now the main contact.",
  "Kontakt löschen?": "Delete contact?",
  "{name} wird entfernt. Nachrichten und Vorgänge bleiben erhalten.": "{name} will be removed. Messages and cases are kept.",
  "Kontakt gelöscht.": "Contact deleted.",
  "Kontakt": "Contact",
  "Noch keine Kontakte": "No contacts yet",
  "Kontakte mit E-Mail-Adresse sind die Grundlage der Absenderprüfung im Service Hub.": "Contacts with an email address are the basis for sender verification in the Service Hub.",
  "Funktion": "Position",
  "Hauptkontakt": "Main contact",
  "mobil {nummer}": "mobile {nummer}",
  "Als Hauptkontakt setzen": "Set as main contact",
  "Neuer Kontakt": "New contact",
  "Anrede": "Salutation",
  "Vorname": "First name",
  "Nachname *": "Surname *",
  "z. B. Technischer Inspektor": "e.g. Technical Superintendent",
  "Grundlage der Absenderprüfung im Service Hub": "Basis for sender verification in the Service Hub",
  "Mobil": "Mobile",
  "gleiche USt-IdNr.": "same VAT ID",
  "gleiche Domain": "same domain",
  "ähnlicher Name": "similar name",
  "Bitte die Firma eintragen.": "Please enter the company name.",
  "Bitte eine Kundennummer eintragen.": "Please enter a customer number.",
  "Das Land bitte als zweistelligen Code eintragen, z. B. DE, DK, GR.": "Please enter the country as a two-letter code, e.g. DE, DK, GR.",
  "USt-IdNr.: {meldung}": "VAT ID: {meldung}",
  "Für innergemeinschaftliche Lieferungen ist die USt-IdNr. Pflicht.": "A VAT ID is mandatory for intra-Community supplies.",
  "Die E-Mail-Adresse für Rechnungen ist ungültig.": "The email address for invoices is invalid.",
  "Das Zahlungsziel bitte in ganzen Tagen eintragen.": "Please enter the payment terms in whole days.",
  "Es gibt mögliche Dubletten. Bitte prüfen und erneut auf Anlegen klicken, um trotzdem anzulegen.": "Possible duplicates found. Please check them and click Create again to proceed anyway.",
  "Interessent {nummer} angelegt.": "Prospect {nummer} created.",
  "Kunde {nummer} angelegt.": "Customer {nummer} created.",
  "Stammdaten gespeichert.": "Master data saved.",
  "Pflichtfelder sind mit * markiert": "Mandatory fields are marked with *",
  "Trotzdem anlegen": "Create anyway",
  "Mögliche Dubletten": "Possible duplicates",
  "Kundennummer *": "Customer number *",
  "Nächste freie Nummer vorgeschlagen": "Next free number suggested",
  "Firma *": "Company *",
  "Zusatz": "Address line 2",
  "z. B. Abteilung Einkauf": "e.g. Purchasing Department",
  "Straße": "Street",
  "PLZ": "Postcode",
  "Ort": "City",
  "Land *": "Country *",
  "ISO-Code, z. B. DE": "ISO code, e.g. DE",
  "E-Mail für Rechnungen": "Email for invoices",
  "Wird aus der E-Mail übernommen: {domain}": "Taken from the email address: {domain}",
  "Für die Absenderprüfung im Service Hub": "For sender verification in the Service Hub",
  "reederei.de": "shipowner.com",
  "USt-IdNr. formal gültig ({nummer})": "VAT ID formally valid ({nummer})",
  "Sprache für Belege und Mails": "Language for documents and emails",
  "Zahlungsziel in Tagen": "Payment terms in days",
  "Kreditlimit in Euro": "Credit limit in EUR",
  "Änderung nur mit dem Recht Kreditlimit ändern": "Changes require the permission to change credit limits",
  "Automatische Eingangsbestätigung senden": "Send automatic acknowledgement of receipt",
  "{name} entfernen": "Remove {name}",
  "Hinzufügen": "Add",
  "Bitte eine Lieferantennummer eintragen.": "Please enter a supplier number.",
  "Das Land bitte als zweistelligen Code eintragen, z. B. DE, NL.": "Please enter the country as a two-letter code, e.g. DE, NL.",
  "Lieferant {nummer} angelegt.": "Supplier {nummer} created.",
  "Lieferantennummer *": "Supplier number *",
  "Sprache für Anfragen": "Language for enquiries",
  "Mit Enter übernehmen, z. B. MAN, Wärtsilä, Alfa Laval": "Press Enter to add, e.g. MAN, Wärtsilä, Alfa Laval",
  "Marke hinzufügen": "Add brand",
  "Zustand der Teile": "Condition of parts",
  "Übliche Lieferzeit in Tagen": "Usual lead time in days",
  "Bitte den Schiffsnamen eintragen.": "Please enter the vessel name.",
  "Das Baujahr liegt außerhalb des gültigen Bereichs.": "The year built is outside the valid range.",
  "Die MMSI hat neun Ziffern.": "The MMSI has nine digits.",
  "Die IMO {imo} ist bereits vergeben.": "IMO {imo} is already in use.",
  "{name} angelegt.": "{name} created.",
  "Schiff umbenannt, der alte Name steht in der Historie.": "Vessel renamed; the former name is kept in the history.",
  "Schiffsdaten gespeichert.": "Vessel particulars saved.",
  "Die IMO-Nummer ist der feste Schlüssel des Schiffs": "The IMO number is the permanent identifier of the vessel",
  "Vorhanden als": "Exists as",
  "Beim Speichern wird der bisherige Name {name} mit dem heutigen Datum in die Historie geschrieben. Belege und Vorgänge bleiben unverändert.": "On saving, the previous name {name} is written to the history with today's date. Documents and cases remain unchanged.",
  "Name *": "Name *",
  "IMO-Nummer": "IMO number",
  "7 Ziffern": "7 digits",
  "IMO-Prüfziffer stimmt.": "IMO check digit is correct.",
  "Bauwerft": "Shipyard",
  "BRZ": "GT",
  "Tragfähigkeit (tdw)": "Deadweight (DWT)",
  "Technischer Bereederer": "Technical manager",
  "Üblicher Agent, Häfen, Besonderheiten. Wird beim Versand vorgeschlagen.": "Usual agent, ports, special requirements. Suggested at shipping.",
  "Tag {tag} entfernen": "Remove tag {tag}",
  "Tag eingeben, Enter fügt hinzu": "Type a tag, Enter adds it",
  "Tag hinzufügen": "Add tag",
  "Containerschiff": "Container ship",
  "Massengutfrachter": "Bulk carrier",
  "Tanker": "Tanker",
  "Chemikalientanker": "Chemical tanker",
  "Mehrzweckfrachter": "Multi-purpose vessel",
  "Fähre": "Ferry",
  "RoRo": "Ro-Ro",
  "Schlepper": "Tug",
  "Offshore-Versorger": "Offshore supply vessel",
  "Kühlschiff": "Reefer",
  "Gastanker": "Gas carrier",
  "Forschungsschiff": "Research vessel",
  "Hauptmotor": "Main engine",
  "Hilfsdiesel": "Auxiliary engine",
  "Turbolader": "Turbocharger",
  "Separator": "Separator",
  "Kompressor": "Compressor",
  "Pumpe": "Pump",
  "Kessel": "Boiler",
  "Frischwassererzeuger": "Fresh water generator",
  "Ruderanlage": "Steering gear",
  "Kran": "Crane",
  "{firma} zusammenführen": "Merge {firma}",
  "Wird zusammengeführt …": "Merging …",
  "Zusammenführen": "Merge",
  "Kontakte, Vorgänge, Nachrichten, Schiffe und Belegentwürfe von {nr} gehen auf den gewählten Kunden über. Leere Felder dort werden ergänzt. Ausgestellte Belege bleiben nach GoBD unverändert bei {nr} und erscheinen beim Zielkunden mit. {nr} wird danach inaktiv.": "Contacts, cases, messages, vessels and draft documents of {nr} move to the selected customer. Empty fields there are filled in. Issued documents stay unchanged with {nr} as required by GoBD and are shown with the target customer. {nr} is then set to inactive.",
  "Zielkunde suchen": "Search target customer",
  "Firma, Kundennummer oder Ort": "Company, customer number or city",
  "Keine naheliegende Dublette gefunden. Bitte den Zielkunden suchen.": "No obvious duplicate found. Please search for the target customer.",
  "Mögliche Dubletten nach USt-IdNr., Domain und Name:": "Possible duplicates by VAT number, domain and name:",
  "Zielkunde": "Target customer",
  "{quelle} wird in {ziel} ({nr}) überführt. Das lässt sich nicht automatisch rückgängig machen.": "{quelle} will be merged into {ziel} ({nr}). This cannot be undone automatically.",
  "Dieser Kunde wurde zusammengeführt.": "This customer has been merged.",
  "Zum Zielkunden": "Go to target customer",
  "Enthält zusammengeführte Kunden: {liste}. Deren ausgestellte Belege und offene Posten erscheinen hier mit.": "Includes merged customers: {liste}. Their issued documents and open items are shown here as well.",
  "Zusammengeführt: {k} Kontakte, {v} Vorgänge, {n} Nachrichten.": "Merged: {k} contacts, {v} cases, {n} messages.",
  "Eine IBAN beginnt mit dem Länderkürzel und zwei Prüfziffern, z. B. DE89.": "An IBAN starts with the country code and two check digits, e.g. DE89.",
  "Unbekanntes Länderkürzel {land}.": "Unknown country code {land}.",
  "Eine IBAN aus {land} hat {soll} Zeichen, eingegeben sind {ist}.": "An IBAN from {land} has {soll} characters, {ist} entered.",
  "Die Prüfziffer stimmt nicht. Bitte jede Stelle mit der Vorlage vergleichen (Zahlendreher?).": "The check digits do not match. Please compare every character with the source (swapped digits?).",
  "Die Bankleitzahl hat 8 Ziffern.": "The German bank code has 8 digits.",
  "Die Kontonummer hat 1 bis 10 Ziffern.": "The account number has 1 to 10 digits.",
  "IBAN gültig": "IBAN valid",
  "{bank} · BIC {bic}": "{bank} · BIC {bic}",
  "IBAN gültig. Die Bank steht nicht im Verzeichnis; BIC bitte von der Rechnung oder vom Lieferanten übernehmen.": "IBAN valid. The bank is not in the directory; please take the BIC from the invoice or the supplier.",
  "Die eingetragene BIC passt nicht zur Bank der IBAN ({bic}).": "The BIC entered does not match the IBAN's bank ({bic}).",
  "Kontoinhaber": "Account holder",
  "IBAN aus Kontonummer und Bankleitzahl berechnen": "Calculate IBAN from account number and bank code",
  "Bankleitzahl": "Bank code (BLZ)",
  "Kontonummer": "Account number",
  "Diese Bankleitzahl steht nicht im Verzeichnis der Bundesbank.": "This bank code is not in the Bundesbank directory.",
  "Für deutsche Konten. Einige Banken haben Sonderregeln; die IBAN bitte mit einem Beleg der Bank abgleichen.": "For German accounts. Some banks have special rules; please check the IBAN against a bank document.",
  "IBAN übernehmen": "Use IBAN",
  "Gesperrt: Abweichung prüfen": "Blocked: check difference",
  "IBAN ungültig: {grund}": "IBAN invalid: {grund}",
  "IBAN {neu} weicht von der IBAN im Lieferantenstamm ab ({alt}). Vor der Zahlung beim Lieferanten über eine bekannte Telefonnummer bestätigen lassen.": "IBAN {neu} differs from the IBAN in the supplier master ({alt}). Confirm with the supplier via a known phone number before paying.",
  "{nr}: {m} berechnet, {e} geliefert": "{nr}: {m} invoiced, {e} delivered",
  "Mehr berechnet als geliefert: {liste}": "More invoiced than delivered: {liste}",
  "Nicht in der Bestellung: {liste}": "Not in the purchase order: {liste}",
  "Keine Berechtigung, den Lieferantenstamm zu ändern.": "No permission to change the supplier master.",
  "Bankverbindung bei {name} gespeichert.": "Bank details saved for {name}.",
  "Drei-Wege-Abgleich und Bankprüfung": "three-way match and bank check",
  "Im Lieferantenstamm: {iban}": "In supplier master: {iban}",
  "wie im Lieferantenstamm": "same as supplier master",
  "Als Bankverbindung des Lieferanten speichern": "Save as the supplier's bank details",
  "IBAN: {meldung}": "IBAN: {meldung}",
  "Grundlage für Überweisungen. Weicht die IBAN auf einer Rechnung davon ab, sperrt Merkan die Zahlung, bis jemand die Änderung bestätigt (Schutz vor Rechnungsbetrug).": "Basis for transfers. If the IBAN on an invoice differs, Merkan blocks payment until someone confirms the change (protection against invoice fraud).",
  "Für Rückzahlungen, Gutschriften und später SEPA-Lastschriften.": "For refunds, credit notes and later SEPA direct debits.",
  // Branchenneutrale Fassungen (Mandanten ohne Schiffsakte)
  "Kunden und Interessenten": "Customers and prospects",
  "firma.de": "company.com",
  "Kontakte, Vorgänge, Nachrichten und Belegentwürfe von {nr} gehen auf den gewählten Kunden über. Leere Felder dort werden ergänzt. Ausgestellte Belege bleiben nach GoBD unverändert bei {nr} und erscheinen beim Zielkunden mit. {nr} wird danach inaktiv.": "Contacts, cases, messages and draft documents of {nr} move to the selected customer. Empty fields there are filled in. Issued documents stay unchanged with {nr} as required by GoBD and are shown with the target customer. {nr} is then set to inactive.",

  // Stammdatenabgleich
  "Abgelehnt": "Rejected",
  "Abgleich": "Reconciliation",
  "Abweichungen zwischen Belegen und Stamm: aus Eingangsrechnungen, Mails im Service Hub und dem Rechnungsarchiv.": "Differences between documents and master data: from supplier invoices, Service Hub mails and the invoice archive.",
  "Alle Vorschläge übernommen.": "All suggestions applied.",
  "Alle übernehmen": "Apply all",
  "Alte Ausgangsrechnungen als PDF auswählen, zum Beispiel den Export aus Sage. {ki} liest je Rechnung Kundennummer und Rechnungsanschrift, ordnet den Kunden zu und legt Vorschläge an, wo die Anschrift vom Stamm abweicht.": "Select old sales invoices as PDF, for example the export from Sage. {ki} reads the customer number and billing address of each invoice, matches the customer and creates suggestions where the address differs from the master data.",
  "Anhalten": "Stop",
  "Archiv": "Archive",
  "Archiv abgleichen": "Reconcile archive",
  "Bei mehreren Rechnungen eines Kunden zählt die neueste. Höchstens 300 Dateien je Durchgang. Jede Datei verbraucht etwas KI-Kontingent.": "With several invoices for one customer, the newest counts. At most 300 files per run. Each file uses some AI quota.",
  "Der Abgleich ist noch nicht eingerichtet (Datenbank-Update ausstehend).": "Reconciliation is not set up yet (database update pending).",
  "Diese Angaben weichen in aktuellen Belegen vom Stamm ab. Prüfen und übernehmen oder ablehnen.": "These details differ from the master data in recent documents. Review and apply or reject.",
  "Geänderte Kundendaten aus Belegen": "Changed customer data from documents",
  "Geänderte Lieferantendaten aus Belegen": "Changed supplier data from documents",
  "Im Stamm geändert": "Changed in master data",
  "Keine offenen Vorschläge": "No open suggestions",
  "Mail": "Mail",
  "Nicht zugeordnet": "Not matched",
  "Noch nichts entschieden": "Nothing decided yet",
  "Offene Vorschläge": "Open suggestions",
  "Rechnungen auswählen": "Select invoices",
  "Rechnungsarchiv abgleichen": "Reconcile invoice archive",
  "Stammdatenabgleich": "Master data reconciliation",
  "Stammsatz": "Record",
  "Stimmt überein": "Matches",
  "Unbekannter Fehler": "Unknown error",
  "Vorschlag abgelehnt. Dieser Wert wird nicht erneut vorgeschlagen.": "Suggestion rejected. This value will not be suggested again.",
  "Weichen Anschrift, USt-IdNr. oder Bankverbindung in einem Beleg vom Stamm ab, erscheint hier ein Vorschlag.": "If the address, VAT ID or bank details in a document differ from the master data, a suggestion appears here.",
  "aus {n} Beleg": "from {n} document",
  "aus {n} Belegen": "from {n} documents",
  "leer": "empty",
  "{feld} übernommen.": "{feld} applied.",
  "{n} Abweichung": "{n} difference",
  "{n} Abweichungen": "{n} differences",
  "{n} Stammsatz": "{n} record",
  "{n} Stammsätze": "{n} records",
  "{n} Vorschlag": "{n} suggestion",
  "{n} Vorschläge": "{n} suggestions",
  "{n} Vorschläge konnten nicht übernommen werden.": "{n} suggestions could not be applied.",
  "{n} ohne Kundenzuordnung": "{n} without customer match",
  "{n} von {gesamt} gelesen": "{n} of {gesamt} read",
  "Änderungsvorschläge": "Change suggestions",
  "Übernommen": "Applied",
} satisfies Record<string, string>;
